import type { BrandDefinition } from '../types';
import {
  disabledAdminModules,
  disabledStorefrontPaths,
} from './routes';
import { tenantDefaults } from './tenantDefaults';

const brand: BrandDefinition = {
  id: 'catalogofworks',
  displayName: 'Catalog of Works',
  domains: {
    apex: 'catalogofworks.com',
    tenantSuffix: 'catalogofworks.com',
  },
  capabilities: {
    commerce: true,
    biography: true,
    platformDirectory: true,
    lightroom: true,
    telegram: true,
    editorialCollection: false,
    manualProductSku: true,
  },
  tenantDefaults: {
    listOnPlatform: tenantDefaults.listOnPlatform,
    allowGuestCart: tenantDefaults.allowGuestCart,
    allowGuestOrders: tenantDefaults.allowGuestOrders,
  },
  tenantModuleGroups: null,
  disabledStorefrontPaths,
  disabledAdminModules,
  components: {
    PlatformLanding: null,
  },
};

export default brand;
